/**
 * PaperPop Shopify Theme - Cart Drawer
 * Enhanced cart functionality
 */

class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('[data-cart-overlay]');
    this.closeBtns = this.drawer.querySelectorAll('[data-cart-close]');
    this.itemsContainer = this.drawer.querySelector('[data-cart-items]');
    
    this.bindEvents();
  }

  bindEvents() {
    // Close events
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    // Keyboard escape
    if (!this.keyboardBound) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });
      this.keyboardBound = true;
    }

    // Item actions
    if (!this.drawerClickBound) {
      this.drawer.addEventListener('click', (e) => this.handleItemClick(e));
      this.drawerClickBound = true;
    }
  }

  handleItemClick(e) {
    const minusBtn = e.target.closest('[data-quantity-minus]');
    const plusBtn = e.target.closest('[data-quantity-plus]');
    const removeBtn = e.target.closest('[data-remove-item]');

    if (minusBtn) {
      this.updateItemQuantity(minusBtn, -1);
    } else if (plusBtn) {
      this.updateItemQuantity(plusBtn, 1);
    } else if (removeBtn) {
      this.removeItem(removeBtn);
    }
  }

  updateItemQuantity(btn, change) {
    const item = btn.closest('[data-cart-item]');
    const quantityEl = item.querySelector('[data-quantity-value]');
    const line = item.dataset.line;
    
    let quantity = parseInt(quantityEl.textContent) + change;
    if (quantity < 1) quantity = 1;
    
    quantityEl.textContent = quantity;
    
    this.updateCartLine(line, quantity);
  }

  removeItem(btn) {
    const item = btn.closest('[data-cart-item]');
    const line = item.dataset.line;
    
    item.style.opacity = '0.5';
    item.style.pointerEvents = 'none';
    
    this.updateCartLine(line, 0);
  }

  async updateCartLine(line, quantity) {
    try {
      const response = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ line, quantity })
      });

      const cart = await response.json();
      this.updateCartUI(cart);
      
      // Dispatch custom event
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      
    } catch (error) {
      console.error('Cart update error:', error);
    }
  }

  updateCartUI(cart) {
    // Update cart count badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });

    // Update cart total
    const cartTotal = document.querySelector('[data-cart-total]');
    if (cartTotal) {
      cartTotal.textContent = this.formatMoney(cart.total_price);
    }

    // If cart is empty, refresh the drawer
    if (cart.item_count === 0) {
      this.refreshDrawer();
    }
  }

  async refreshDrawer() {
    try {
      const response = await fetch(window.routes.cart_url);
      const html = await response.text();
      
      // Parse and update drawer content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('[data-cart-drawer]');
      
      if (newDrawer && this.drawer) {
        this.drawer.innerHTML = newDrawer.innerHTML;
        this.overlay = this.drawer.querySelector('[data-cart-overlay]');
        this.closeBtns = this.drawer.querySelectorAll('[data-cart-close]');
        this.itemsContainer = this.drawer.querySelector('[data-cart-items]');
        this.bindEvents();
      }
    } catch (error) {
      console.error('Drawer refresh error:', error);
    }
  }

  open() {
    this.drawer.classList.add('cart-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('cart-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    document.body.style.overflow = '';
  }

  isOpen() {
    return this.drawer.classList.contains('cart-drawer--open');
  }

  formatMoney(cents) {
    const format = window.Shopify?.money_format || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', value);
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
});
